import { useId } from 'react';
import { Trans } from '@lingui/react/macro';
import { useLanguage } from '../i18n/provider';
import './LanguageSelect.css';

export default function LanguageSelect() {
  const id = useId();
  const { preference, persistenceError, setPreference } = useLanguage();

  return (
    <div className="language-select">
      <label htmlFor={id}><Trans>Language</Trans></label>
      <select
        id={id}
        value={preference}
        aria-describedby={persistenceError ? `${id}-warning` : undefined}
        onChange={(event) => {
          const value = event.target.value;
          if (value !== 'system' && value !== 'en' && value !== 'zh-CN') {
            throw new Error(`Unsupported language preference: ${value}`);
          }
          setPreference(value);
        }}
      >
        <option value="system"><Trans>Follow system</Trans></option>
        <option value="en" lang="en">English</option>
        <option value="zh-CN" lang="zh-CN">简体中文</option>
      </select>
      {persistenceError && (
        <p id={`${id}-warning`} className="language-select-warning" role="status">
          <Trans>Your language choice could not be saved in this browser. It will apply until this page is closed.</Trans>
        </p>
      )}
    </div>
  );
}
